import { render, staticRenderFns } from "./scrollbar.vue?vue&type=template&id=2974dbf3&scoped=true&"
import script from "./scrollbar.js?vue&type=script&lang=js&"
export * from "./scrollbar.js?vue&type=script&lang=js&"
import style0 from "./scrollbar.scss?vue&type=style&index=0&id=2974dbf3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2974dbf3",
  null
  
)

export default component.exports